import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import TelegramIcon from '@mui/icons-material/Telegram';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import telegram from '../assets/images/telegram.png';
import facebook from '../assets/images/facebook.png';

const buildMarker = `build-marker:commit:${process.env.REACT_APP_BUILD_COMMIT || 'local'};loaded:${new Date().toISOString()}`;

const useStyles = makeStyles((theme) => ({
  footer: {
    height: '15vh',
    backgroundColor: '#FFFFFF',
    borderRadius: '30px 30px 0px 0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 24px',
    color: '#0A0A13',
    fontSize: '16px',
    fontWeight: 500,
    textAlign: 'left',
    marginTop: '50px',
  },
  footerTitle: {
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  socialIcons: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    color: 'black',
    margin: '0 8px',
    fontSize: 24,
    '&:hover': {
      color: 'blue',
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: '15px',
    },
  },
}));

function Footer() {
  const classes = useStyles();
  return (
      <div>
      <Grid item xs={12}>
                <Grid container className={classes.footer}>
                  <Grid className={classes.footerTitle}>
                    <Typography style={{fontSize: '16px', fontWeight: '500'}}>
                      <span>
                             &copy;
                                     {' '}
                                       {1900 + new Date().getYear()}
                                     {' '}
                       </span> Мінсоцполітики {buildMarker && <label hidden={true}>{buildMarker}</label>}</Typography>
                    <Typography style={{fontSize: '16px', fontWeight: '500'}}>Розробник: <a href="http://www.ioc.gov.ua">ДП ІОЦ Мінсоцполітики</a></Typography>
                  </Grid>
                  <Grid item>
                    <div className={classes.socialIcons}>
                      <Typography style={{fontSize: '16px', fontWeight: '500'}}>Слідкуй за нами тут:</Typography>
                      <a href="https://m.facebook.com/MLSP.gov.ua">
                        {' '}
                        <FacebookOutlinedIcon className={classes.icon}/>
                      </a>
                     
                      <a href="https://t.me/MinSocUA">
                        {' '}
                        <TelegramIcon className={classes.icon}/>
                      </a>
                    </div>
                  </Grid>
                  </Grid>
                  </Grid>

      </div>
  );
}

export default Footer;
